import { ProjectType } from 'types'
import { ProjectsTechnic, IntroDescription, IntroLink } from './styled'
export const ProjectIntro: React.FC<{
  project: ProjectType
}> = ({ project }) => {
  if (!project) return null
  return (
    <IntroDescription>
      <h2>
        {project.name} <span>({project.year})</span>
      </h2>

      <p>{project.intro}</p>
      {project.technics.length > 0 &&
        project.technics.map((technic, index) => {
          return (
            <ProjectsTechnic key={`${technic}-${index}`}>
              {technic}
            </ProjectsTechnic>
          )
        })}
      {project.link && project.link.length > 0 && (
        <IntroLink
          target="_blank"
          rel="noreferrer noopener"
          href={project.link}
        >
          link
        </IntroLink>
      )}
    </IntroDescription>
  )
}
